module.exports = __webpack_public_path__ + "img/sitchDot200px-min.png";